/**
 * Constants are in a separate file because otherwise there is a circular dependency of:
 *   env -> domains -> env
 */

export const DEV = 'dev';
export const SIT = 'sit';
export const STAGE = 'stage';
export const PROD = 'prod';
export const ENVIRONMENTS = [DEV, SIT, STAGE, PROD];
